var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapFireBurntAreaFieldObs = function SvgFiremapFireBurntAreaFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E131C2",
    clipPath: "url(#firemap-fire-burnt-area-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.005 24.144 23.432-26.61 1.501 1.322-23.432 26.61zM-1.496 10.178 8.182-.812 9.682.51.006 11.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-fire-burnt-area-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.52 1.52h20.96v20.96H1.52z"
  })))));
};
export default SvgFiremapFireBurntAreaFieldObs;